import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { Info } from 'lib/styles';

import ListSelectedItems from '../common/ListSelectedItems';
import PictogramItem from './PictogramItem';
import Title from './Title';
import Adjustment from './Adjustment';
import Settings from './Settings';

const Container = styled.div`
	padding: 16px 40px;
`;

const Pictogram = props => {
	const {
		t,
		lng,
		data: {
			data,
			options
		},
		activeIndex,
		buildingFieldLocalNames,
		viewSettings,
	} = props;
	let title = data.title[lng];
	const localFieldNames = buildingFieldLocalNames[lng];
	const activePictogramData = activeIndex in data.pictograms ? data.pictograms[activeIndex] : {};
	const activePictogramDataWithChanges = {
		...activePictogramData,
		...props.unsavedChanges,
	};

	if ('title' in props.unsavedChanges && lng in props.unsavedChanges.title) {
		title = props.unsavedChanges.title[lng];
	}



	const items = data.pictograms.map((pictogram, index) => {
		const pictogramData = props.pictograms.find(_pictogram => _pictogram.field === pictogram.field);
		const svg = typeof pictogramData !== 'undefined' ? pictogramData.image : '';
		return {
			id: pictogram.field,
			selected: activeIndex === index,
			element: <PictogramItem image={svg} localName={localFieldNames[pictogram.field]} />
		}
	});

	return (
		<Container>
			{ viewSettings ?
				<Settings
					options={options}
					updateSettingsHandler={props.updateSettingsHandler}
				/> :
				<React.Fragment>
					<Title
						title={title}
						onChange={title => props.changesHandler({
							title: {
								...props.unsavedChanges.title,
								[lng]: title
							}
						})}
					/>

					<ListSelectedItems
						viewItems={props.viewItems}
						activeIndex={activeIndex}
						activeIndexHandler={props.activeIndexHandler}
						viewItemsText="controls/pictogram/select items"
						viewItemsToggleHandler={props.viewItemsToggleHandler}
						saveHandler={props.saveHandler}
						onSortEndHandler={props.onSortEndHandler}
						items={items}
					/>

					{ activeIndex !== -1 &&
				<Adjustment
				  value={activePictogramDataWithChanges.i18n}
				  onChange={value => props.changesHandler({
				    i18n: {
				      ...props.unsavedChanges.i18n,
				      [lng]: value
				    }
				  })}
				/>
					}

					<Info
						icon="light-bulb"
						fill="orange"
						info={t('controls/pictogram/info/default')}
					/>
				</React.Fragment>}
		</Container>
	)
}

Pictogram.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.oneOf(['fi', 'en']),
	unsavedChanges: PropTypes.object,
	pictograms: PropTypes.array,
	buildingFieldLocalNames: PropTypes.object,
	viewItems: PropTypes.bool,
	activeIndex: PropTypes.number,
	data: PropTypes.object,
	changesHandler: PropTypes.func,
	activeIndexHandler: PropTypes.func,
	viewItemsToggleHandler: PropTypes.func,
	saveHandler: PropTypes.func,
	onSortEndHandler: PropTypes.func,
	viewSettings: PropTypes.bool,
	updateSettingsHandler: PropTypes.func,
}

export default translate('translations')(Pictogram)
